module.exports = __webpack_public_path__ + "img/product28803p.03fe6526.png";